// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { endLab } from '../../apis/lab';
import { endLabActions } from '../actionCreators/endLabActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: endLabActions.success,
  failure: endLabActions.failure
};

type RequestActionTypes = ActionType<
  typeof endLabActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const endLabEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(endLabActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, callback } = action.payload;
      // send api promise
      return endLab(id)
        .then((response: any) => {
          // handle success case here
          return endLabActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return endLabActions.failure({ error });
        })
        .finally(() => callback && callback())
    })
  );
};
